import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Fragment } from 'react';
import { ContainerVertical, ContainerHorizontal } from '@aftersale-next/ui';
import WhatsappConfirmation from './whatsapp-confirmation';
import SMSConfirmation from './sms-confirmation';
import ChannelSelectorList from './channel-selector-list';
import * as channel from '../../config/constants/channel';
import { useChannelSelection } from '../../hooks/use-channel-selection';
import DisableNotificationConfirmation from './disable-notification-confirmation';
import EmailConfirmation from './email-confirmation';
/**
 * Channel chooser
 *
 * @param props
 * @constructor
 */

export function ChannelSelector() {
  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      selected = _useChannelSelection2[0],
      setSelected = _useChannelSelection2[1];

  var handleSelect = function handleSelect(id) {
    return setSelected(id);
  };

  if (selected) {
    switch (selected) {
      case channel.SMS:
        return /*#__PURE__*/_jsx(SMSConfirmation, {});

      case channel.WHATSAPP:
        return /*#__PURE__*/_jsx(WhatsappConfirmation, {});

      case channel.NOT_DISTURB:
        return /*#__PURE__*/_jsx(DisableNotificationConfirmation, {});

      case channel.EMAIL:
        return /*#__PURE__*/_jsx(EmailConfirmation, {});

      default:
        return /*#__PURE__*/_jsx(Fragment, {});
    }
  }

  return /*#__PURE__*/_jsx(ContainerHorizontal, {
    children: /*#__PURE__*/_jsx(ContainerVertical, {
      justify: "center",
      align: "flex-start",
      minHeight: "160px",
      fullWidth: true,
      children: /*#__PURE__*/_jsx(ChannelSelectorList, {
        onSelect: handleSelect
      })
    })
  });
}